import { useRouter } from 'next/router';

import { SiteURL } from '../constants';

export const useGetUrlForCurrentPage = () => {
  const { asPath } = useRouter();
  const origin = typeof window !== 'undefined' && window.location.origin ? window.location.origin : SiteURL;
  return origin + asPath;
};
